import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const C1FormLabelStyles: moduleStyleType = {
    root: {
        mb: 1,
    },
}
